// Step 1
// Get the Membership ProductStep
import Product from "../product-component/product";

export default function SecondaryProductStep({
  currentStep,
  languages,
  locationDataCurrency,
  locationData,
  products,
  selectMembership,
  isProductLoaded,
  error,
  goNextStep,
  stepNo,
}) {
  if (currentStep !== stepNo) {
    return null;
  }

  if (products && products.length === 0) {
    goNextStep();
  }

  return (
    <div className="card-wrapper flex justify-evenly">
      <Product
        languages={languages}
        locationData={locationData}
        isProductLoaded={isProductLoaded}
        error={error}
        products={products}
        selectMembership={selectMembership}
        locationDataCurrency={locationDataCurrency}
      />
    </div>
  );
}
